import React from 'react';
import { Card } from '../ui/Card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  trend?: {
    value: string;
    direction: 'up' | 'down';
    label: string;
  };
  icon: React.ReactNode;
  color?: 'teal' | 'blue' | 'purple' | 'amber' | 'red';
}
export function MetricCard({
  title,
  value,
  trend,
  icon,
  color = 'teal'
}: MetricCardProps) {
  const colors = {
    teal: 'bg-teal-50 text-teal-600',
    blue: 'bg-blue-50 text-blue-600',
    purple: 'bg-purple-50 text-purple-600',
    amber: 'bg-amber-50 text-amber-600',
    red: 'bg-red-50 text-red-600'
  };
  return <Card className="relative overflow-hidden" data-id="element-167">
      <div className="flex items-start justify-between" data-id="element-168">
        <div data-id="element-169">
          <p className="text-sm font-medium text-slate-500" data-id="element-170">{title}</p>
          <h3 className="text-2xl font-bold text-slate-900 mt-2" data-id="element-171">{value}</h3>
        </div>
        <div className={`p-3 rounded-lg ${colors[color]}`} data-id="element-172">{icon}</div>
      </div>

      {trend && <div className="mt-4 flex items-center text-sm" data-id="element-173">
          <span className={`flex items-center font-medium ${trend.direction === 'up' ? 'text-emerald-600' : 'text-red-600'}`} data-id="element-174">
            {trend.direction === 'up' ? <ArrowUpRight className="h-4 w-4 mr-1" data-id="element-175" /> : <ArrowDownRight className="h-4 w-4 mr-1" data-id="element-176" />}
            {trend.value}
          </span>
          <span className="text-slate-500 ml-2" data-id="element-177">{trend.label}</span>
        </div>}
    </Card>;
}